import { returnServiceTypes } from '../../constants/returns';
import { scrollToTop } from '../../utils/window';

const {
  BACK_TO_LANDING,
  HRTV_SUCCESS,
  SSR_RESET,
  SSR_CREATE_SUCCESS,
  SSR_CREATE_ERROR,
  SSR_ERROR,
  RETURNS_400_ERROR,
  RETURNS_500_ERROR,
} = returnServiceTypes;

export const initialState = {
  page: 'landing',
  ssrReturnsErrorMessage: '',
  showBannerError: false,
  analyticsErrorEvent: 'general',
};

export const goToSsrPage = (state: Object, action: Object) => ({
  ...state,
  page: action.payload.page,
  showBannerError: action.payload.showBannerError || false,
  ssrReturnsErrorMessage: '',
});

export const goToErrorPage = (state: Object, action: Object) => ({
  ...state,
  ssrReturnsErrorMessage: action.payload.message || 'GENERAL_ERROR',
  analyticsErrorEvent: action.payload.analyticsErrorEvent,
});

export const showBannerError = (state: Object) => ({
  ...state,
  showBannerError: true,
});

export const setOrderId = (state: Object, action: Object) => ({
  ...state,
  orderId: action.payload.orderId,
});

const ssrPage = (state: Object = initialState, action: Action) => {
  const newState = Object.assign({}, state);
  switch (action.type) {
    case SSR_RESET:
    case BACK_TO_LANDING:
      return initialState;
    case HRTV_SUCCESS:
      return goToSsrPage(newState, action);
    case SSR_CREATE_SUCCESS:
      return goToSsrPage(newState, action);
    case SSR_CREATE_ERROR:
      return goToSsrPage(newState, action);
    case SSR_ERROR:
      return goToErrorPage(newState, action);
    case RETURNS_400_ERROR:
      return goToErrorPage(newState, action);
    case RETURNS_500_ERROR:
      scrollToTop();
      return showBannerError(newState);
    default:
      return state;
  }
};

export default ssrPage;

export const getAnalyticsErrorEvent = (state: Object) =>
  state.returnService.ssrPage.analyticsErrorEvent;
